import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus } from "lucide-react";
import { Field } from "@/components/erp";
import { Input } from "@/components/ui/input";
import { SelectBox } from "@/components/Inputs";
import { useAuth } from "@/context/AuthContext";
import { secenek } from "@/lib/cari";
import api, { errMsg } from "@/lib/api";

export const VARSAYILAN_DEPARTMANLAR = [
  { ad: "Yönetim", uretim: false, gorevler: ["Genel Müdür", "Müdür", "Sekreter", "Danışman"] },
  { ad: "Üretim", uretim: true, gorevler: ["Üretim Müdürü", "Sekreter", "Vardiya Şefi", "Usta", "Operatör", "İşçi"] },
  { ad: "Satış ve Pazarlama", uretim: false, gorevler: ["Satış Müdürü", "Sekreter", "Satış Temsilcisi", "Bayi Sorumlusu", "Pazarlama Uzmanı"] },
  { ad: "Muhasebe ve Finans", uretim: false, gorevler: ["Muhasebe Müdürü", "Sekreter", "Muhasebe Uzmanı", "Finans Uzmanı"] },
  { ad: "Depo ve Sevkiyat", uretim: false, gorevler: ["Depo Müdürü", "Sekreter", "Depo Sorumlusu", "Sevkiyat Sorumlusu", "Şoför", "Forklift Operatörü"] },
  { ad: "Satın Alma", uretim: false, gorevler: ["Satın Alma Müdürü", "Sekreter", "Satın Alma Uzmanı"] },
  { ad: "Kalite", uretim: false, gorevler: ["Kalite Müdürü", "Sekreter", "Kalite Kontrol Uzmanı"] },
  { ad: "İnsan Kaynakları", uretim: false, gorevler: ["İK Müdürü", "Sekreter", "İK Uzmanı"] },
];

export const useDepartmanlar = () => {
  const { ayar } = useAuth();
  return ayar?.departmanlar?.length ? ayar.departmanlar : VARSAYILAN_DEPARTMANLAR;
};

export const DepartmanSecim = ({ f, set }) => {
  const deps = useDepartmanlar();
  const { user, loadAyar } = useAuth();
  const [istasyonlar, setIstasyonlar] = useState([]);
  const [yeni, setYeni] = useState(null);
  const dep = deps.find((d) => d.ad === f.departman);
  useEffect(() => { if (dep?.uretim) api.get("/istasyonlar").then((r) => setIstasyonlar(r.data)).catch(() => {}); }, [dep?.uretim]);
  const gorevler = dep?.gorevler || [];
  const depSec = (v) => { set("departman", v); set("gorev", ""); if (!deps.find((d) => d.ad === v)?.uretim) set("istasyon_id", ""); };
  const gorevEkle = async () => {
    const ad = (yeni || "").trim();
    if (!ad) return;
    if (!gorevler.includes(ad)) {
      try { await api.put("/ayarlar", { departmanlar: deps.map((d) => (d.ad === dep.ad ? { ...d, gorevler: [...d.gorevler, ad] } : d)) }); await loadAyar(); toast.success(`"${ad}" görevi ${dep.ad} departmanına eklendi`); } catch (e) { return toast.error(errMsg(e)); }
    }
    set("gorev", ad); setYeni(null);
  };
  return (
    <>
      <Field label="Departman *"><SelectBox testid="cari-departman" value={f.departman || ""} onChange={depSec} options={deps.map((d) => ({ value: d.ad, label: d.ad }))} /></Field>
      {dep?.uretim && <Field label="Çalıştığı İstasyon *"><SelectBox testid="cari-istasyon" value={f.istasyon_id || ""} onChange={(v) => set("istasyon_id", v)} placeholder={istasyonlar.length ? "İstasyon seçin" : "Tanımlı istasyon yok"} options={istasyonlar.map((i) => ({ value: i.id, label: i.ad }))} /></Field>}
      <Field label="Görev *"><div className="flex gap-2"><div className="flex-1 min-w-0"><SelectBox testid="cari-gorev" value={f.gorev || ""} onChange={(v) => set("gorev", v)} placeholder={dep ? "Görev seçin" : "Önce departman seçin"}
        options={secenek(f.gorev && !gorevler.includes(f.gorev) ? [f.gorev, ...gorevler] : gorevler)} /></div>
        {dep && user?.role === "admin" && <button type="button" data-testid="cari-gorev-ekle" title="Yeni görev ekle" onClick={() => setYeni("")} className="h-10 w-10 shrink-0 rounded-md border border-white/15 inline-flex items-center justify-center hover:bg-white/5"><Plus className="w-4 h-4" /></button>}</div>
        {yeni !== null && <div className="flex gap-2 mt-2"><Input data-testid="cari-gorev-yeni" autoFocus placeholder="Örn. Çırak, Bakım Operatörü" className="bg-white/5" value={yeni} onChange={(e) => setYeni(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); gorevEkle(); } }} />
          <button type="button" data-testid="cari-gorev-yeni-kaydet" onClick={gorevEkle} className="px-3 h-9 rounded-md bg-emerald-600 text-white text-sm">Ekle</button><button type="button" onClick={() => setYeni(null)} className="px-3 h-9 rounded-md border border-white/15 text-sm">Vazgeç</button></div>}</Field>
    </>
  );
};
